import { call, put, takeEvery, takeLeading, select } from 'redux-saga/effects';
import { getDashboardConferences } from '@services/dashboardResource';
import { tokenSelector } from '@selectors/authentication';
import { types } from '@actions/conferences';
import { isEmpty } from "lodash/lang";
import {
  regeneratePin,
  transformConferenceResponse,
  cancelConference,
  callAttendeeFromConference,
} from '@services/conferenceResource';

export function* dashboardGetConferencesSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const { data } = yield call(
      getDashboardConferences,
      action.pageNumber,
      action.numberPerPage,
      token,
      action.filters,
    );
    const conferences = {
      meta: data.meta,
      list: data.transcripts.map(transformConferenceResponse, false),
    };
    yield put({
      type: types.GET_CONFERENCES_LIST.SUCCESS,
      ...conferences,
    });
  } catch (err) {
    yield put({
      type: types.GET_CONFERENCES_LIST.FAILURE,
      message: err.message || 'Failed to fetch conferences list.',
    });
  }
}

export function* regeneratePinFromDashboardSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const { response } = (yield call(regeneratePin, action.conferenceId, token)).data;
    if (isEmpty(response) || isEmpty(response.pin)) {
      yield put({
        type: types.REGENERATE_PIN_FROM_DASHBOARD.FAILURE,
        message: 'Unable to generate a valid PIN. Please retry.',
      });
    } else {
      yield put({
        type: types.REGENERATE_PIN_FROM_DASHBOARD.SUCCESS,
        conferenceId: action.conferenceId,
        ...response,
        message: 'New PIN has been generated.',
      });
    }
  } catch (err) {
    yield put({
      type: types.REGENERATE_PIN_FROM_DASHBOARD.FAILURE,
      message: err.message || 'Error when generating new PIN.',
    });
  }
}

export function* cancelConferenceCallSaga(action) {
  try {
    const token = yield select(tokenSelector);
    yield call(cancelConference, action.conferenceId, token);
    yield put({
      type: types.CANCEL_CONFERENCE_CALL.SUCCESS,
      conferenceId: action.conferenceId,
      message: 'Conference call has been canceled.',
    });
  } catch (err) {
    yield put({
      type: types.CANCEL_CONFERENCE_CALL.FAILURE,
      message: err.message || 'Error when canceling the conference.',
    });
  }
}

export function* callAttendeeSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const payload = {
      attendeeId: action.attendeeId,
      id: action.conferenceId,
    };
    const { data } = yield call(callAttendeeFromConference, token, payload);
    yield put({
      type: types.CALL_ATTENDEE.SUCCESS,
      data,
      message: 'Call has been succesfully initiated.',
    });
  } catch (err) {
    yield put({
      type: types.CALL_ATTENDEE.FAILURE,
      message: err.message || 'Error while calling Attendee.',
    });
  }
}

export default function*() {
  yield takeEvery(types.GET_CONFERENCES_LIST.STARTED, dashboardGetConferencesSaga);
  yield takeEvery(
    types.REGENERATE_PIN_FROM_DASHBOARD.STARTED,
    regeneratePinFromDashboardSaga,
  );
  yield takeEvery(types.CANCEL_CONFERENCE_CALL.STARTED, cancelConferenceCallSaga);
  yield takeLeading(types.CALL_ATTENDEE.STARTED, callAttendeeSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/conferences.js